import { PUBLIC_TRIAL_TIERS } from "../../shared/subscriptionPlans";

export const FREE_TRIAL_DAYS = 7;
export const FREE_TRIAL_DOMAIN_LIMIT = 3;
export const FREE_TRIAL_PLANS = [...PUBLIC_TRIAL_TIERS];

export const FREE_TRIAL_LABEL = `7-day free trial for up to ${FREE_TRIAL_DOMAIN_LIMIT} domains`;

export const formatTrialEndLabel = (value?: string | null) => {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toLocaleString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const getTrialDaysRemaining = (value?: string | null) => {
  if (!value) return null;
  const endMs = Date.parse(value);
  if (!Number.isFinite(endMs)) return null;
  return Math.max(0, Math.ceil((endMs - Date.now()) / (1000 * 60 * 60 * 24)));
};
